import type { ITheme, IThemeVariationProperties } from '@belong/types';
import { BREAKPOINTS, cssUnit, FONT_MAP, FONT_SIZE, SPACES } from './helpers';
import { getThemeVariations } from './theme-variations';

export * from './helpers';
export * from './GlobalStyles';
export * from './theme-variations';

let currentTheme: ITheme;
let currentThemeDark: ITheme;

export const getTheme = ({
  isDark = false
}: {
  isDark?: boolean;
} = {}): ITheme => {
  if (!currentTheme) {
    setTheme();
  }

  return isDark ? currentThemeDark : currentTheme;
};

const setTheme = (): void => {
  const themeVariations = getThemeVariations();

  const baseTheme: Omit<ITheme, keyof IThemeVariationProperties> = {
    breakpoints: { ...BREAKPOINTS },

    fonts: {
      base: FONT_MAP,
      fontSize: FONT_SIZE
    },

    spaces: SPACES,
    cssUnit
  };

  currentTheme = {
    ...baseTheme,
    ...themeVariations.Light
  };

  currentThemeDark = {
    ...baseTheme,
    ...themeVariations.Dark
  };
};
